import { Add, Cancel } from '@mui/icons-material';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    List,
    ListItem,
    ListItemSecondaryAction,
    ListItemText,
    TextField,
} from '@mui/material';
import React, { useState } from 'react';

interface MultipleChoiceDialogProps {
  open: boolean;
  options: string[];
  onAddOptions: (options: string[]) => void;
  onRemoveOption: (index: number) => void;
  onClose: () => void;
}

const MultipleChoiceDialog: React.FC<MultipleChoiceDialogProps> = ({
  open,
  options,
  onAddOptions,
  onRemoveOption,
  onClose,
}) => {
  const [newOption, setNewOption] = useState('');

  const handleAddOption = () => {
    if (newOption.trim()) {
      onAddOptions(newOption.split(',').map((opt: string) => opt.trim()));
      setNewOption('');
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Manage Multiple Choice Options</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', gap: 1, mb: 2, mt: 1 }}>
          <TextField
            fullWidth
            size="small"
            label="Option1, Option2, Option3, ..."
            value={newOption}
            onChange={(e) => setNewOption(e.target.value)}
          />
          <IconButton onClick={handleAddOption} color="primary">
            <Add />
          </IconButton>
        </Box>
        <List>
          {options.map((option, index) => (
            <ListItem key={index}>
              <ListItemText primary={option} />
              <ListItemSecondaryAction>
                <IconButton
                  edge="end"
                  onClick={() => onRemoveOption(index)}
                  color="error"
                >
                  <Cancel />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default MultipleChoiceDialog;